export function createExpertiseCard(block, parent) {
    const blockName = block.data_block_name;

    const wrapper = document.createElement('div');
    wrapper.className = 'expertise-card-block';
    wrapper.setAttribute('data-block-name', blockName);
    wrapper.setAttribute('data-block-id', block.id || '');
    wrapper.setAttribute('data-order', String(block.order ?? 0));

    wrapper.innerHTML = `
        <section class="expertise-slide expertise-container container-fluid">
            <div class="row h-100">
                <div class="col-lg-6 col-md-6 d-flex justify-content-between">
                    <div class="slide-bar d-flex flex-column h-100">
                    </div>
                    <div class="slide-content">
                        <img class="image-main-expertise"
                             data-content="${blockName}-main-image"
                             data-page="expertise"
                             data-type="image"
                             data-attribute="image"
                             data-global="false"
                             src="" alt="">
                    </div>
                </div>
                <div class="expertise-description-container col-lg-6 col-md-6 d-flex flex-column justify-content-between">
                    <div class="row slide-content">
                        <div class="col-md-10">
                            <h3 class="expertise-title" data-content="${blockName}-title" data-page="expertise" data-global="false">${block.content || ''}</h3>
                            <p class="expertise-description"
                               data-content="${blockName}-description"
                               data-page="expertise"
                               data-type="textarea"
                               data-attribute="html"
                               data-global="false"></p>
                            <a href="#" class="expertise-learn-more inactive">Дізнатися більше</a>
                        </div>
                        <div class="col-md-2 text-end">
                            <svg class="star-burst star-animated animate" width="38" height="40" viewBox="0 0 38 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.5186 38.99C19.4711 39.6322 18.5289 39.6322 18.4814 38.99L17.5271 26.0906C17.4928 25.6263 16.9123 25.4377 16.6116 25.7932L8.25748 35.6681C7.84158 36.1597 7.07937 35.6059 7.4184 35.0584L14.2284 24.0617C14.4736 23.6658 14.1148 23.1721 13.6626 23.2829L1.09965 26.3614C0.474218 26.5147 0.183081 25.6187 0.77915 25.375L12.7523 20.4813C13.1833 20.3052 13.1833 19.6948 12.7523 19.5187L0.779151 14.625C0.183078 14.3813 0.474219 13.4853 1.09965 13.6385L13.6626 16.7171C14.1148 16.8279 14.4736 16.3341 14.2284 15.9383L7.4184 4.94155C7.07936 4.39409 7.84158 3.84031 8.25748 4.33192L16.6116 14.2068C16.9123 14.5623 17.4928 14.3737 17.5272 13.9093L18.4814 1.00996C18.5289 0.36778 19.4711 0.367784 19.5186 1.00997L20.4729 13.9093C20.5072 14.3737 21.0877 14.5623 21.3884 14.2068L29.7425 4.33192C30.1584 3.84031 30.9206 4.3941 30.5816 4.94155L23.7716 15.9383C23.5264 16.3341 23.8852 16.8279 24.3374 16.7171L36.9004 13.6386C37.5258 13.4853 37.8169 14.3813 37.2209 14.625L25.2477 19.5187C24.8167 19.6948 24.8167 20.3052 25.2477 20.4813L37.2209 25.375C37.8169 25.6187 37.5258 26.5147 36.9004 26.3614L24.3374 23.2829C23.8852 23.1721 23.5264 23.6658 23.7716 24.0617L30.5816 35.0584C30.9206 35.6059 30.1584 36.1597 29.7425 35.6681L21.3884 25.7932C21.0877 25.4377 20.5072 25.6263 20.4729 26.0906L19.5186 38.99Z" fill="#0090B8"/>
                            </svg>
                        </div>
                    </div>
                    <div class="row slide-content">
                        <div class="col-md-5"></div>
                        <div class="expertise-inner-image-container col-md-7 d-flex justify-content-center">
                            <img class="expertise-inner-image"
                                 data-content="${blockName}-inner-image-1"
                                 data-page="expertise"
                                 data-type="image"
                                 data-attribute="image"
                                 data-global="false"
                                 src="" alt="">
                            <img class="expertise-inner-image"
                                 data-content="${blockName}-inner-image-2"
                                 data-page="expertise"
                                 data-type="image"
                                 data-attribute="image"
                                 data-global="false"
                                 src="" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    `;

    parent.appendChild(wrapper);
    return wrapper;
}

export const expertiseCardProps = {
    name: 'expertise-card',
    title: 'Картка Експертизи',
    description: 'Картка з назвою, описом та зображеннями',
    allowedParents: ['expertises-section'],
    requiresPage: false,
    contentFields: [
        { name: 'title', type: 'text', label: 'Назва' },
        { name: 'description', type: 'textarea', label: 'Опис' },
        { name: 'main-image', type: 'image', label: 'Головне зображення' },
        { name: 'inner-image-1', type: 'image', label: 'Внутрішнє зображення 1' },
        { name: 'inner-image-2', type: 'image', label: 'Внутрішнє зображення 2' },
    ]
};
